import React from 'react'

import AmenidadesSidebar from './canvas/sidebar/amenidadesSidebar.component';
import Camera from './canvas/camera/camera.component';
import Sidebar from './canvas/sidebar/sidebar.component';
import BeneficiosSidebar from './canvas/sidebar/beneficiosSidebar.component';
import EtapasSidebar from './canvas/sidebar/etapasSidebar.component';

import GeneralGallery from './canvas/gallery/generalGallery.component'
import Recorrido360 from './canvas/recorrido360/recorrido360.component'
import Viewer360 from './canvas/viewer360/viewer360.component'

import Bubbles from './canvas/overlays/bubbles.component'
import Billboards from './canvas/overlays/billboards.component'

import MapComponent from './canvas/map/dynamicMap.component'

import { ContextLoader } from "./../utils/import.frames";
import  Icons from './../utils/import.icons'
import Recorridos from './../utils/import.recor360'

import MobileCheck from './../utils/mobileCheck'

import {ContextTransitions} from './../utils/import.transits'
import { TypeAngles } from '../utils/export.angles'

import disponible from './../UI/icons/Dispo/disponible.png'
import reservado from './../UI/icons/Dispo/reservado.png'
import vendido from './../UI/icons/Dispo/vendido.png'

interface Canvas {
    mainCameraRef: any
    secondaryCameraRef: any
    bubblesRef: any
    billboardsRef: any,
    galleryRef: any,
    viewer360ref: any,
    mapRef: any,
}

interface Props{
    isWelcome: boolean
    proyecto: any,
    textures: any,
    loadedImages: number
}

interface State{
    initFramePOI: number,
    initFramePOIsecondary: number,
    isPreTransition: boolean,
    isSidebarHidden: boolean,

    isAmenidades: boolean,
    isBeneficios: boolean,
    isVias: boolean,
    isEtapas: boolean,
    
    towerTransition: boolean,
    showGeneralView: boolean,
    showBubbles: boolean,
    showMap: boolean
    loadingCanvas: boolean,

    cameraAngle: number
    mainCameraAngle: number,

    hasControl: boolean,

    sidebarBtnSelected: string,
    secondaryBtnSelected: string

    zoom: number
    leftOffset: any,
    topOffset: any,
    links: any,
    linksSecondary: any,

    selectedEtapa: string,
    selectedTorre: string,
    selectedAptoTipo: string,
    selectedAptoTipoCategory: string,
    selectedPOI: any,

    openSecondaryCamera: boolean,
    is180: boolean,
    initFrame180: number,
    bubbleAngle: number,
    rotateForBubble: boolean,

    generalGalleryOpened: boolean,
    recorrido360Opened: boolean, 
    aptoRecor360Name: string,

    open360Render: boolean,
    current360Image: string,

    isMobile: boolean
    showBillboards: boolean,
    animateMap: boolean,
    mapCenter: any,
    mapZoom: any,
    selectedZonaInteres: any,
    fullUpdate: any,
    direction: any,
    galleryIndex: any,
    lockedControl: any,
    vistaMap: boolean,

    selectedAptos: any,
    selectedNumeroApto: any,
    selectedFloor: any,

    isFormCotizacion: boolean,
    isTransicion: boolean,
    aptosCotizados: any
}

interface Links {
    data?: any,
    ContextLoader: any
}

class Canvas extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            initFramePOI: 0,
            initFramePOIsecondary: 0,
            isPreTransition: false,
            isSidebarHidden: false,

            isAmenidades: false,
            isBeneficios: false,
            isVias: false,
            isEtapas: false,

            towerTransition: false,
            showGeneralView: true,
            showBubbles: false,
            showMap: false,
            loadingCanvas: false,

            cameraAngle: 0,
            mainCameraAngle: 0,

            hasControl: false,

            sidebarBtnSelected: "",
            secondaryBtnSelected: "",

            zoom: 1,
            leftOffset: 0,
            topOffset: 0,
            links: [],
            linksSecondary: [],

            selectedEtapa: "",
            selectedTorre: "",
            selectedAptoTipo: "",
            selectedAptoTipoCategory: "",
            selectedPOI: [],

            openSecondaryCamera: false,
            is180: false,
            initFrame180: 0,
            bubbleAngle: 0,
            rotateForBubble: false,

            generalGalleryOpened: false,
            recorrido360Opened: false,
            aptoRecor360Name: "",
            open360Render: false,
            current360Image: "",

            isMobile: false,
            showBillboards: false,
            animateMap: false,
            mapCenter: 0,
            mapZoom: 0,
            selectedZonaInteres: [],
            fullUpdate: [],
            direction: -1,
            galleryIndex: -1,
            lockedControl: false,
            vistaMap: false,
            selectedAptos: [],
            selectedNumeroApto: "",
            selectedFloor: "",

            isFormCotizacion: false,
            isTransicion: false,
            aptosCotizados: []
        }

        this.bubblesRef = React.createRef();
        this.mainCameraRef = React.createRef();
        this.secondaryCameraRef = React.createRef();
        this.galleryRef = React.createRef();
        this.mapRef = null;
        this.viewer360ref = React.createRef();
    }

    componentDidMount(){
        const mobile = MobileCheck()
        this.setState({isMobile: mobile})
        this.handleLoadGeneralView()
    }

    componentDidUpdate(prevProps: any){

        if(prevProps.isWelcome !== this.props.isWelcome){

            //No Dispo

            /*let availability: any = []

            this.props.proyecto.Etapas.forEach((etapa: any) => {
                etapa.Torres.forEach((torre: any) => {
                    availability[torre.Nombre] = []
                    torre.AptosTipo.forEach((aptoTipo: any) => {
                        availability[torre.Nombre].push({
                            tipo: aptoTipo.Categoria,
                            t: torre.Nombre,
                            a: aptoTipo
                        })
                    })
                    
                    this.bubblesRef.current.updateAvailability(availability[torre.Nombre], torre.Nombre)
                })
            })*/

            //Dispo

            let availability: any = [];
            this.props.proyecto.Etapas.forEach((etapa: any) => {
                etapa.Torres.forEach((torre: any) => {
                    availability[torre.Nombre] = []
                    torre.AptosTipo.forEach((aptoTipo: any) => {
                        aptoTipo.Aptos.forEach((apto: any) => {
                            availability[torre.Nombre].push({
                                tipo: aptoTipo.Nombre,
                                num: apto.Numero,
                                disp: apto.Disponibilidad,
                                t: torre.Nombre,
                                a: aptoTipo
                            })
                        })
                    })

                    this.bubblesRef.current.updateAvailability(availability[torre.Nombre], torre.Nombre)
                })
            })
        }
    }

    handleBackBtn = () => {
        this.setState({
            isAmenidades: false,
            isBeneficios: false,
            isVias: false,
            isEtapas: false,

            showBubbles: false,
            showMap: false,

            sidebarBtnSelected: "",
            secondaryBtnSelected: "",
            linksSecondary: [],
            selectedEtapa: "",
            selectedTorre: "",
            selectedAptoTipo: "",
            selectedPOI: [],
            openSecondaryCamera: false,
            is180: false,
            generalGalleryOpened: false,
            aptoRecor360Name: "",
            open360Render: false,
            current360Image: "",

            showBillboards: false,
            animateMap: false,
            selectedZonaInteres: [],
            vistaMap: false,
        }, () => {this.handleLoadGeneralView()})

        
    }

    handleLoadGeneralView = () => {
        this.setState({
            links: [],
            openSecondaryCamera: false
        }, () => {
            var data = ContextLoader["General View"]()

            data.map((data: any, index: number) => {
                this.setState(prevState => ({
                    links: [...prevState.links, data],
                    is180: ContextLoader["General View"]().length === 36,
                }))
        })
        })

        this.handleGeneralViewGallery()
    }

    handleGeneralViewGallery = () => {
        this.props.proyecto.Amenidades.map((amenidad: any, index: number) => {
            if(amenidad.Nombre === "General View" && this.state.secondaryBtnSelected === ""){
                this.setState({
                    selectedPOI: amenidad
                })
            }
        })
    }

    handleStartTransicion = () => {

        this.setState({isMobile: true})
        this.handleEndTransicion();
    };

    handleSecondaryCameraAngleUpdate = (angle: number) => {
        this.setState({
            cameraAngle: angle,
        });
    };

    handleMainCameraAngleUpdate = (angle: number) => {
        this.setState({
            mainCameraAngle: angle,
        });
    };
    
    handleEndTransicion = () => {
        if (this.state.towerTransition) {
            this.setState({
                isPreTransition: false,
                showGeneralView: false,
                showBubbles: false,
                towerTransition: false,
                loadingCanvas: false
            })
        } else {
            this.setState({
                isPreTransition: false
            })
        }
    };

    on360Ready = () => {
        this.setState({
            loadingCanvas: false,
        })
     };

    notifyZoomAndOffsets = (zoom: number, leftOffset: any, topOffset: any) => {
        this.setState({
            zoom: zoom,
            leftOffset: leftOffset,
            topOffset: topOffset
        });
    }

    handleHideSideBar = () => {
        this.setState({
            isSidebarHidden: !this.state.isSidebarHidden
        })
    }

    handleOpenVias = (payload: string) => {
        this.setState({
            sidebarBtnSelected: payload,
            isAmenidades: false,
            isBeneficios: false,
            isEtapas: false,
            isVias: true,
            selectedPOI: [],
            showMap: true,
            selectedZonaInteres: [],
            animateMap: false,
            vistaMap: true,
            selectedTorre:"",
            selectedAptoTipo:"",
        })
    }

    handleOpenBeneficios = (payload: string) => {
        this.setState({
            sidebarBtnSelected: payload,
            isBeneficios: true,
            isVias: false,
            isAmenidades: false,
            isEtapas: false,
            secondaryBtnSelected: this.props.proyecto.PuntosDeInteres[0].nombre,
            selectedPOI: [],
            open360Render: false,
            current360Image: "",
            linksSecondary: [],
            showBillboards: false,
            openSecondaryCamera: false,
            selectedZonaInteres: this.props.proyecto.PuntosDeInteres[0],
            animateMap: false,
            vistaMap: true,
            selectedTorre:"",
            selectedAptoTipo:"",
        })
        
    }

    handleOpenAmenidades = (payload: string) => {
        this.setState({
            sidebarBtnSelected: payload,
            isVias: false,
            isAmenidades: true,
            isBeneficios: false,
            isEtapas: false,
            showBubbles: false,
            openSecondaryCamera: false,
            selectedTorre:"",
            selectedAptoTipo:"",
            selectedPOI: []
        })

        this.handleLoadGeneralView()
    }

    handleOpenEtapas = (payload: string) => {
        this.setState({
            sidebarBtnSelected: payload,
            isVias: false,
            isAmenidades: false,
            isBeneficios: false,
            isEtapas: true,
            secondaryBtnSelected: "",
            selectedPOI: [],
            open360Render: false,
            current360Image: "",
            linksSecondary: [],
            showBillboards: false,
            openSecondaryCamera: false,
            showBubbles: false,
            selectedEtapa: "",
            selectedAptoTipo: "",
            selectedTorre: ""
        })
    }

    handleShowBeneficios = (nombre: string, icon: string, beneficio: any) => {
        this.setState({
            secondaryBtnSelected: nombre,
            selectedZonaInteres: beneficio,
            animateMap: false
        })
    } 

    handleShowAmenidad = (nombre: any, icono: string, amenidad: any) => {
        if(this.state.secondaryBtnSelected !== nombre){
            this.setState({
                secondaryBtnSelected: nombre,
                selectedPOI: amenidad
            })
            const data: Links = {ContextLoader}
            if(data.ContextLoader[nombre]){
                if(data.ContextLoader[nombre]().length === 2){
                    this.setState({
                        open360Render: true,
                        current360Image: this.state.isMobile ? data.ContextLoader[nombre]()[1]:data.ContextLoader[nombre]()[0],
                        loadingCanvas: true
                    })
                }
                else{
                    this.setState({
                        linksSecondary: [],
                        is180: data.ContextLoader[nombre]().length === 36,
                        openSecondaryCamera: true,
                        open360Render: false,
                        current360Image: "",
                        loadingCanvas: true
                    }, () => {
                        data.ContextLoader[nombre]().map((data: any, index: number) => {
                            
                            this.setState(prevState => ({
                                linksSecondary: [...prevState.linksSecondary, data],
                            }))
                        })
                        if(ContextTransitions.hasOwnProperty(nombre)){
                            var origenTransicionIndex = ContextTransitions[nombre];
                            this.setState({
                                initFramePOIsecondary: origenTransicionIndex.initFrame,
                                isPreTransition: true,
                            })
                        }
                    })
                } 
            }
            else{
                this.setState({
                    open360Render: false,
                    current360Image: "",
                    showBillboards: true,
                    openSecondaryCamera: false
                }, () => {this.handleLoadGeneralView()})
                if(ContextTransitions.hasOwnProperty(nombre)){
                    var origenTransicionIndex = ContextTransitions[nombre];
                    this.setState({
                        initFramePOI: origenTransicionIndex.initFrame,
                        isPreTransition: true,
                    }, () => {this.handleLoadGeneralView()})
                }
            }
        }
    }


    handleSelectedEtapas = (nombre: string) => {
        this.setState({
            selectedEtapa: nombre
        })
    }

    handleSelectedTorres = (nombre: any) => {
        this.setState({
            selectedAptoTipo: "",
            selectedPOI: [],
            selectedTorre: nombre,
        })
        var data: Links = {ContextLoader}
        if(nombre !== ""){
            if(data.ContextLoader[nombre]()){
                this.setState({
                    linksSecondary: [],
                    openSecondaryCamera: true,
                    is180: data.ContextLoader[nombre]().length === 36,
                    loadingCanvas: true
                }, () => {
                    data.ContextLoader[nombre]().map((data: any, index: number) => {
                        this.setState(prevState => ({
                            linksSecondary: [...prevState.linksSecondary, data],
                        }))
                    })
                    if(ContextTransitions.hasOwnProperty(nombre)){
                        var origenTransicionIndex = ContextTransitions[nombre];
                        this.setState({
                            initFramePOIsecondary: origenTransicionIndex.initFrame,
                            isPreTransition: true,
                        })
                    }
                })
            }
        }
        else{
            this.handleLoadGeneralView()
        }
    }

    handleSelectedAptosTipo = (nombre: string, aptoTipo: any) => {
        console.log(aptoTipo)
        this.setState({
            selectedAptoTipo: nombre,
            selectedPOI: aptoTipo,
            bubbleAngle: TypeAngles[nombre] !== undefined ? TypeAngles[nombre]:80,
            rotateForBubble: true
        })
    }

    rotateForBubbleEnded = () => {
        this.setState({
            rotateForBubble: false
        })
    }

    onReadyTorres = () => {
        if (this.state.isEtapas) {
            this.setState({
                showBubbles: true,
                loadingCanvas: false
            })
        } else {
            this.setState({
                loadingCanvas: false
            })
        }
    };

    forceUpdateBubbles = (images: any) => {
        if (this.state.isEtapas) {
            this.bubblesRef.current.forceUpdateCall(images);
        }
    };

    handleGeneralGallery = () => {
        this.setState({
            generalGalleryOpened: !this.state.generalGalleryOpened
        })
    }

    handleBubbleGallery = (aptoTipo: any) => {
        this.setState({
            generalGalleryOpened: !this.state.generalGalleryOpened,
            selectedPOI: aptoTipo
        })
    }

    handleBubble360 = (aptoTipo: any) => {
        this.setState({
            recorrido360Opened: !this.state.recorrido360Opened,
            aptoRecor360Name: aptoTipo
        })
    }

    changeAnimation = (params: boolean) => {
        this.setState({
            animateMap: params
        })
    };

    updateMapDataTour = (payload) =>{
        this.setState({
            mapCenter: payload.mapCenter,
            mapZoom: payload.mapZoom
        })
    }

    updateFromTourData = (payload) => {
            if(payload){
            
            if(this.state.showGeneralView && payload.mainCameraAngle && !this.state.is180){
                this.mainCameraRef.current.updateFromTourData(payload.mainCameraAngle);
            }
        
            if(payload.cameraAngle && !this.state.showGeneralView && !this.state.open360Render || this.state.is180){
                if(this.secondaryCameraRef.current){
                this.secondaryCameraRef.current.updateFromTourData(payload.cameraAngle);
                }
            }
            
            if(this.mapRef && payload.mapZoom && payload.mapCenter){
                this.mapRef.updateMap(payload.mapCenter, payload.mapZoom)
            }
        
            if(this.galleryRef.current && payload.openGaleria){
                this.galleryRef.current.updateGalleryFromTour(payload.galleryIndex)
            }
        
            if(this.viewer360ref.current && payload.direction){
                this.viewer360ref.current.updateDirectionFromTour(payload.direction);
            }
            
            console.log('updated to:', payload)
            this.state.fullUpdate({...payload})
            //console.log('new props: ', this.props)
            }
    }
    
    update360Tour = (payload: any) =>{
        console.log('update360Tour:', payload)
        this.setState({
        direction: payload
        })
    }
    
    updateGalleryTour = (index: number) =>{
        this.setState({
        galleryIndex: index
        })
    }
    
    setControlLock = (locked: boolean) =>{
        console.log('locked:', locked)
        this.setState({
        lockedControl: locked
        })
    }
    
    updateHasControl = (hasControl: boolean) =>{
        this.setState({
        hasControl: hasControl
        })
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isWelcome ? "maqueta-page fade-in":"maqueta-page fade-out"}>
                {
                    this.props.isWelcome ?
                    <div className='canvas-content'>
                        <div className='canvas-3d' id='canvas-content'>
                            <Camera 
                                useSubdirectories={false}
                                links={this.state.links}
                                initFramePOI={this.state.initFramePOI}
                                isPreTransition={this.state.isPreTransition}
                                handleStartTransicion={this.handleStartTransicion}
                                handleAngleUpdate={this.handleMainCameraAngleUpdate}
                                onReady={() => {this.setState({loadingCanvas: false})}}
                                is180={false}
                                notifyZoomAndOffsets={this.notifyZoomAndOffsets}              
                                ref={this.mainCameraRef}
                                hasControl={this.state.hasControl}
                            />
                            {
                                <div className={this.state.openSecondaryCamera ? 'secondary-camera fade-in':'secondary-camera fade-out'}>
                                    <Camera 
                                        useSubdirectories={false}
                                        links={this.state.linksSecondary}
                                        onReady={this.onReadyTorres}
                                        initFramePOI={this.state.initFramePOIsecondary}
                                        isPreTransition={this.state.isPreTransition}
                                        is180={this.state.is180}
                                        onForceUpdateBubbles={this.forceUpdateBubbles}
                                        secondary={true}
                                        handleAngleUpdate={this.handleSecondaryCameraAngleUpdate}
                                        rotateForBubble={this.state.rotateForBubble}
                                        handleRotateForBubbleEnded={this.rotateForBubbleEnded}
                                        bubbleAngle={this.state.bubbleAngle}
                                        handleStartTransicion={this.handleStartTransicion}
                                        notifyZoomAndOffsets={this.notifyZoomAndOffsets}
                                        ref={this.secondaryCameraRef}
                                        hasControl={this.state.hasControl}
                                    />
                                </div>
                            }
                        </div>
                        <Bubbles
                            ref={this.bubblesRef}
                            angle={this.state.cameraAngle}
                            show={this.state.showBubbles}
                            tower={this.state.selectedTorre}
                            category={this.state.selectedAptoTipo}
                            loadingCanvas={this.state.loadingCanvas}
                            apto={this.state.selectedAptoTipo}
                            zoom={this.state.zoom}
                            leftOffset={this.state.leftOffset}
                            topOffset={this.state.topOffset}
                            handleGeneralGallery = {this.handleBubbleGallery}
                            handle360Click = {this.handleBubble360}
                        >
                        </Bubbles>
                        <Billboards
                            ref = {this.billboardsRef}                  
                            show = {this.state.showBillboards}
                            angle = {this.state.mainCameraAngle}
                            amenity = {this.state.selectedPOI}
                            gallery = {this.state.selectedPOI.Galeria}
                            openGallery = {this.handleBubbleGallery}
                            zoom={this.state.zoom}
                            leftOffset={this.state.leftOffset}
                            topOffset={this.state.topOffset}
                        />
                        {
                        <Viewer360
                            isViewer360 = {this.state.open360Render}
                            currentImage = {this.state.current360Image}
                            on360ready = {this.on360Ready}
                        />
                        }
                        {
                        <MapComponent 
                            showedMap={this.state.showMap}
                            textures={this.props.textures}
                            proyecto={this.props.proyecto}
                            puntosInteres={this.state.selectedZonaInteres}
                            animate={this.state.animateMap}
                            changeAnimation={this.changeAnimation}
                            isVias={this.state.isVias}
                            isBeneficios={this.state.isBeneficios}
                            childRef={ref => (this.mapRef = ref)}
                            notifyMapData={this.updateMapDataTour}
                        />
                        }
                        <AmenidadesSidebar
                            isAmenidades={this.state.isAmenidades}
                            isSidebarHidden={this.state.isSidebarHidden}
                            proyecto={this.props.proyecto.Amenidades}
                            secondaryBtnSelected = {this.state.secondaryBtnSelected}
                            handleShowAmenidad = {this.handleShowAmenidad}
                        />
                        <BeneficiosSidebar 
                            isBeneficios={this.state.isBeneficios}
                            isSidebarHidden={this.state.isSidebarHidden}
                            proyecto={this.props.proyecto.PuntosDeInteres}
                            secondaryBtnSelected = {this.state.secondaryBtnSelected}
                            handleShowBeneficios = {this.handleShowBeneficios}
                        />
                        <EtapasSidebar 
                            isEtapas={this.state.isEtapas}
                            isSidebarHidden={this.state.isSidebarHidden}
                            proyecto={this.props.proyecto.Etapas}
                            selectedEtapa={this.state.selectedEtapa}
                            handleSelectedEtapas = {this.handleSelectedEtapas}
                            selectedTorre={this.state.selectedTorre}
                            handleSelectedTorres = {this.handleSelectedTorres}
                            selectedAptoTipo={this.state.selectedAptoTipo}
                            handleSelectedAptosTipo = {this.handleSelectedAptosTipo}
                        />
                        <Sidebar 
                            proyecto = {this.props.proyecto}
                            textures = {this.props.textures}
                            isSidebarHidden = {this.state.isSidebarHidden}
                            handleHideSidebar={this.handleHideSideBar}
                            sidebarBtnSelected={this.state.sidebarBtnSelected}
                            handleOpenVias={this.handleOpenVias}
                            handleOpenBeneficios={this.handleOpenBeneficios}
                            handleOpenAmenidades={this.handleOpenAmenidades}
                            handleOpenEtapas={this.handleOpenEtapas}
                        />
                    </div>:null
                    }
                    {
                        <div className={this.state.selectedTorre !== "" ? "gizmos-dispo fade-in":"gizmos-dispo fade-out"}>
                            <div className='individual-gizmo'>
                                <img src={disponible}/>
                                <div>Disponible</div>
                            </div>
                            <div className='individual-gizmo'>
                                <img src={reservado}/>
                                <div>Reservado</div>
                            </div>
                            <div className='individual-gizmo'>
                                <img src={vendido}/>
                                <div>Vendido</div>
                            </div>
                        </div>
                    }
                    
                    
                    {
                        <div 
                            className={
                                ((this.state.selectedPOI.Planos && this.state.selectedPOI.Planos.length > 0) ||
                                (this.state.selectedPOI.Galeria && this.state.selectedPOI.Galeria.length > 0)) &&
                                !this.state.isSidebarHidden
                                ? 
                                "renders-btn fade-in":"renders-btn fade-out"}
                            onClick = {() => {this.handleGeneralGallery()}}
                        >
                            <img src={Icons["renders"]}/>
                        </div>
                    }
                    {
                        <div 
                            className={
                                Object.keys(Recorridos).includes(this.state.selectedAptoTipo) && !this.state.isSidebarHidden
                                ? 
                                "recor360-btn fade-in":"recor360-btn fade-out"}
                            onClick = {() => {this.handleBubble360(this.state.selectedAptoTipo)}}
                        >
                            <img src={Icons["recorridos"]}/>
                        </div>
                    }
                    {
                        <div
                            className={
                                (this.state.isVias || this.state.isAmenidades || this.state.isBeneficios || this.state.isEtapas) && !this.state.isSidebarHidden ?
                                "back-btn fade-in":"back-btn fade-out"
                            }
                            onClick={() => {this.handleBackBtn()}}
                        >
                            <img src={Icons["back"]}/>
                        </div>
                    }
                    {
                        <GeneralGallery 
                            generalGalleryOpened = {this.state.generalGalleryOpened}
                            galleryInfo={this.state.selectedPOI}
                            textures={this.props.textures}
                            handleGeneralGallery={this.handleGeneralGallery}
                        />
                    }
                    
                    {
                        <Recorrido360 
                            recorrido360Opened = {this.state.recorrido360Opened}
                            aptoRecor360Name = {this.state.aptoRecor360Name}
                            handleBubble360 = {this.handleBubble360}
                        />
                    }
                    {
                        <div className={this.state.loadingCanvas ? "canvas-loading fade-in":"canvas-loading fade-out"}>
                            <svg className="loader-circle-canvas" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                                <circle className= 'internal-circle-canvas' cx="75" cy="75" r="70"></circle>
                            </svg>
                            <svg className="loader-circle-over-canvas" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                                <circle className= 'internal-circle-over-canvas' cx="75" cy="75" r="70"></circle>
                            </svg>
                        </div>
                    }
            </div>
        )
    }
}

export default Canvas 